exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-control[data-v-215127a8]{z-index:0}", ""]);

// exports
